import { SubChildCategory } from "../../categories/categories.types";

export const getCategoryAttributeByName = (
  category: SubChildCategory | undefined,
  name: string
) => {
  return category?.attributes?.find((attribute) => attribute.name === name);
};
